// MODULES
import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import EditableField from "../../../components/EditableField/EditableField";
import OptionsList from "../../../components/OptionsList/OptionsList";
import fulfillmentCheck from "./Autogiro.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";
import NumberField from "../../../components/NumberField/NumberField";
import StackLayout from "../../../../../components/layouts/StackLayout/StackLayout";
import Button from "../../../../../components/Button/Button";
import AbstractAutogiro, {ProductSelectionRow} from "../AbstractAutogiro";
import Select from "../../../../../components/Select/Select";
import Validator from "../../../../../classes/Validator";


export default class Autogiro extends AbstractAutogiro {

	static minimumAmountSingleDeposit = 50000;
	static minimumAmountMonthlyDeposit = 1000;

	static productLabel = "Fond";

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {state, props} = this;
		const {availableBanks} = props;
		const {fields, validFields} = state;

		const classes = createClassName("Cob-Autogiro-Odin", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const textClasses = createClassName("description", {
			"contractable": true,
			"expanded": state.textFieldExpanded
		});

		const textClassSingle = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_single.checked
		});

		const textClassMonthly = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_monthly.checked
		});

		/**
		 * Set up the dropdown with selectable banks.
		 */
		let availableBankOptions = [];
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;
			availableBankOptions.push({
				label: bankName,
				value: bankName
			});
		}

		availableBankOptions.push({
			label: "Övriga",
			value: "-"
		});

		let selectedBankIndex = -1;

		if (state.fields.customer_account_bank && state.fields.customer_account_bank.length > 0) {
			let bankFoundInList = false;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) {
					continue;
				}
				selectedBankIndex++;
				if (bankName === state.fields.customer_account_bank) {
					bankFoundInList = true;
					break;
				}
			}

			if (!bankFoundInList && state.fields.customer_account_bank === '-') {
				selectedBankIndex++;
			}
		}

		/**
		 * Create rows for selecting funds when you have decided to make either a single deposit
		 * or to start a monthly savings routine.
		 */
		const autogiroSingleFunds = [];
		for (let i = 1; i <= state.autogiroSingleFundsActive; i++) {
			autogiroSingleFunds.push(ProductSelectionRow(this, true, Autogiro.minimumAmountSingleDeposit, Autogiro.minimumAmountMonthlyDeposit, state.products, "single", i));
		}

		const autogiroMonthlyFunds = [];
		for (let i = 1; i <= state.autogiroMonthlyFundsActive; i++) {
			autogiroMonthlyFunds.push(ProductSelectionRow(this, true, Autogiro.minimumAmountSingleDeposit, Autogiro.minimumAmountMonthlyDeposit, state.products, "monthly", i));
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<p style={{
					margin: "0",
					maxWidth: "620px",
					fontSize: "20px",
					fontWeight: "bold",
					color: "#00747b"
				}}>
					För att du ska kunna sätta in och ta ut pengar, samt månadsspara via Autogiro måste nedan
					Autogiromedgivande fyllas i:
				</p>

				<h3>Autogiromedgivande / Föranmält konto</h3>

				<div className={textClasses}>
					<p>
						Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto eller
						av betalaren senare angivet Konto, på begäran av angiven betalningsmottagare för betalning till
						denne på viss dag (”förfallodagen”) via Autogiro. Betalaren medger att insättning och uttag från
						angivet konto eller av betalaren föranmält konto får göras på begäran av betalaren. Betalaren
						samtycker till att behandling av personuppgifter som lämnats i detta medgivande behandlas av
						betalarens betaltjänstleverantör, betalningsmottagaren, betalningsmottagarens
						betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten.
						Personuppgiftsansvariga för denna personuppgiftsbehandling är betalarens betaltjänstleverantör,
						betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör. Betalaren kan när som
						helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta
						betalarens betaltjänstleverantör. Ytterligare information om behandling av personuppgifter i
						samband med betalningar kan finnas i villkoren för kontot och i avtalet med
						betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att
						tjänsten i sin helhet avslutas.
					</p>
					<div className="expand">
						<div className="first"></div>
						<div className="second"></div>
						<div className="third" onClick={this._onExpandText}>Expandera texten</div>
					</div>
					<div className="contract" onClick={this._onExpandText}>
						Minimera texten
					</div>
				</div>

				<FieldsCollection
					fields={[
						{
							render: (
								<OptionsList
									type="radio"
									orientation="horizontal"
									name="customer_autogiro"
									description="Jag ger mitt medgivande till betalning via autogiro"
									options={state.fields.customer_autogiro.options}
									onChange={this._onChangeAutogiroSelect}
								/>
							)
						}
					]}
				/>

				{!!state.fields.customer_autogiro.options[0].checked && (
					<React.Fragment>

						<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
							<Select
								name="customer_account_bank"
								label="Bank"
								style={{width: "45%", marginRight: "10px"}}
								selectedIndex={selectedBankIndex}
								options={availableBankOptions}
								onChange={this._onSelectBankChange}
							/>

							{fields.customer_account_bank === '-' && (
								<React.Fragment>
									<EditableField
										name="customer_account_bank_custom"
										label="Bankens namn"
										style={{width: "45%"}}
										value={fields.customer_account_bank_custom || ""}
										valid={validFields.customer_account_bank_custom}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
									/>
									<input type="hidden" name="customer_account_bank"
										   value={fields.customer_account_bank_custom}/>
								</React.Fragment>
							)}

							{fields.customer_account_bank !== '-' && (
								<input type="hidden" name="customer_account_bank_custom" value=""/>
							)}
						</div>

						{fields.customer_account_bank === 'Swedbank' && (
							<p style={{background: "#FFFFD5", padding: "10px", fontSize: "12px", margin: "10px 0", maxWidth: "600px"}}>
								Det förekommer att Swedbank har en femte siffra i clearingnumret. Vänligen ange
								enbart de fyra första innan bindestrecket. Exempel: 8214-9 ska anges som 8214.
							</p>
						)}

						<div style={{width: "100%", flexDirection: "row", margin: "5px 0"}}>
							<EditableField
								name="customer_account_bank_clearingno"
								style={{width: "45%", marginRight: "10px"}}
								label="Clearingnummer"
								value={fields.customer_account_bank_clearingno || ""}
								valid={validFields.customer_account_bank_clearingno}
								onChange={this._onClearingFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<EditableField
								name="customer_account_bank_no"
								style={{width: "45%"}}
								label="Kontonummer"
								value={fields.customer_account_bank_no || ""}
								valid={validFields.customer_account_bank_no}
								onChange={this._onAccountFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<input type="hidden" name="customer_account_clearing_no" value={fields.customer_account_bank_clearingno || ""} />
						</div>

						<div className="payments">
							<CheckboxWithName
								label="Jag vill göra en engångsinsättning via Autogiro för att spara i fond/er"
								name="checkbox_autogiro_single"
								value={(fields.customer_autogiro.options[0].checked && fields.checkbox_autogiro_single.checked) ? "yes" : "no"}
								checked={fields.checkbox_autogiro_single.checked}
								onChange={this._onCheckboxChange}
							/>

							<div className={textClassSingle}>
								<div className="inner">
									<div className="funds">
										<div className="amountField">
											<EditableField
												name="customer_autogiro_single_amount"
												label="Belopp"
												className="amount"
												Component={NumberField}
												value={fields.customer_autogiro_single_amount || ""}
												valid={validFields.customer_autogiro_single_amount && fields.customer_autogiro_single_amount >= Autogiro.minimumAmountSingleDeposit}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
											/>
											<span>(min. {Autogiro.minimumAmountSingleDeposit.toLocaleString("sv-SE", {minimumFractionDigits: 0})} SEK)</span>
										</div>

										{autogiroSingleFunds}

										{(state.autogiroSingleFundsSharesTotal < 100 ||
											state.autogiroSingleFundsSharesTotal > 100) && (
											<div className="warning">
												<strong>Var god åtgärda:</strong>
												Summan av fondfördelningen måste vara
												100% (just nu {state.autogiroSingleFundsSharesTotal}%).
											</div>
										)}

										<StackLayout fullWidth>
											<Button
												size="small"
												label="Lägg till fond"
												appearance={state.autogiroSingleFundsActive >= 18 ? "medium" : "primary"}
												disabled={state.autogiroSingleFundsActive >= 18}
												onClick={this._onAddFund.bind(this, "single")}
												filled
											/>

											<Button
												size="small"
												label="Ta bort sista"
												appearance={state.autogiroSingleFundsActive <= 1 ? "medium" : "danger"}
												disabled={state.autogiroSingleFundsActive <= 1}
												onClick={this._onRemoveFund.bind(this, "single")}
											/>
										</StackLayout>
									</div>
								</div>
							</div>

							<CheckboxWithName
								label="Jag vill starta ett månadssparande via Autogiro"
								name="checkbox_autogiro_monthly"
								value={(fields.customer_autogiro.options[0].checked && fields.checkbox_autogiro_monthly.checked) ? "yes" : "no"}
								checked={fields.checkbox_autogiro_monthly.checked}
								onChange={this._onCheckboxChange}
							/>

							<div className={textClassMonthly}>
								<div className="inner">
									<div className="funds">
										<div className="amountField">
											<EditableField
												name="customer_autogiro_monthly_amount"
												label="Belopp"
												className="amount"
												Component={NumberField}
												value={fields.customer_autogiro_monthly_amount || ""}
												valid={validFields.customer_autogiro_monthly_amount && fields.customer_autogiro_monthly_amount >= Autogiro.minimumAmountMonthlyDeposit}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
											/>
											<span>(min. {Autogiro.minimumAmountMonthlyDeposit.toLocaleString("sv-SE", {minimumFractionDigits: 0})} SEK)</span>
										</div>

										{autogiroMonthlyFunds}

										{(state.autogiroMonthlyFundsSharesTotal < 100 ||
											state.autogiroMonthlyFundsSharesTotal > 100) && (
											<div className="warning">
												<strong>Var god åtgärda:</strong> Summan av fondfördelningen måste vara
												100%
												(just nu {state.autogiroMonthlyFundsSharesTotal}%).
											</div>
										)}

										<StackLayout fullWidth>
											<Button
												size="small"
												label="Lägg till fond"
												appearance={state.autogiroMonthlyFundsActive >= 18 ? "medium" : "primary"}
												disabled={state.autogiroMonthlyFundsActive >= 18}
												onClick={this._onAddFund.bind(this, "monthly")}
												filled
											/>

											<Button
												size="small"
												label="Ta bort sista"
												appearance={state.autogiroMonthlyFundsActive <= 1 ? "medium" : "danger"}
												disabled={state.autogiroMonthlyFundsActive <= 1}
												onClick={this._onRemoveFund.bind(this, "monthly")}
											/>
										</StackLayout>
									</div>
								</div>
							</div>

						</div>
					</React.Fragment>
				)}
			</div>
		);
	}

	_onSelectBankChange = (option) => {
		CobHelpers.onViewFieldChange.call(this, "customer_account_bank", option.value);
	};

	_nameIsinFilterer = ({option}, input) => {
		input = input.toLowerCase();

		let matchesIsinNumber = false;
		if (option.isin) {
			const isin = option.isin.toLowerCase();
			matchesIsinNumber = isin.indexOf(input) === 0;
		}

		const name = option.label.toLowerCase();
		return name.indexOf(input) >= 0 || matchesIsinNumber;
	};

	_renderNameIsinOption = ({label, isin}) => (
		<React.Fragment>
			<div className="name">{label}</div>
			<div className="isin">{isin}</div>
		</React.Fragment>
	);

	_onNameIsinChange = (name, option, value) => {
		const indexKey = name.replace("_name", "_index");
		let fundIndexInArray = name.replace("_name", "");
		fundIndexInArray = parseInt(fundIndexInArray.substring(fundIndexInArray.lastIndexOf("_") + 1), 10) - 1;

		let selectedDropdownIndex = -1;
		for (let i = 0; i < this.state.products.length; i++) {
			const fund = this.state.products[i];
			if (fund.isin === value.isin) {
				selectedDropdownIndex = i;
				break;
			}
		}

		const newStateProps = {
			[indexKey]: selectedDropdownIndex,
			fields: this.state.fields
		};

		if (selectedDropdownIndex > -1) {
			const selectedFund = this.state.products[selectedDropdownIndex];

			if (name.indexOf("_monthly") > -1) {
				newStateProps.fields.customer_autogiro_monthly_funds[fundIndexInArray]["customer_autogiro_monthly_fund_" + (fundIndexInArray + 1) + "_name"] = selectedFund.label;
				newStateProps.fields.customer_autogiro_monthly_funds[fundIndexInArray]["customer_autogiro_monthly_fund_" + (fundIndexInArray + 1) + "_isin"] = selectedFund.isin;

				/**
				 * Update state with new values. We reset the amount field to the same value as it already has because
				 * this triggers a revalidation of the form. This is a hack that works, made because of lack of time.
				 * If you find a better way of triggering revalidation, feel free to change.
				 */
				const resetValue = this.state.fields.customer_autogiro_monthly_amount;
				this.setState(newStateProps, function () {
					// triggers revalidation of form after dropdown value has been set
					CobHelpers.onViewFieldChange.call(this, "customer_autogiro_monthly_amount", resetValue);
				});
			}
			else if (name.indexOf("_single") > -1) {
				newStateProps.fields.customer_autogiro_single_funds[fundIndexInArray]["customer_autogiro_single_fund_" + (fundIndexInArray + 1) + "_name"] = selectedFund.label;
				newStateProps.fields.customer_autogiro_single_funds[fundIndexInArray]["customer_autogiro_single_fund_" + (fundIndexInArray + 1) + "_isin"] = selectedFund.isin;

				/**
				 * Update state with new values. We reset the amount field to the same value as it already has because
				 * this triggers a revalidation of the form. This is a hack that works, made because of lack of time.
				 * If you find a better way of triggering revalidation, feel free to change.
				 */
				const resetValue = this.state.fields.customer_autogiro_single_amount;
				this.setState(newStateProps, function () {
					CobHelpers.onViewFieldChange.call(this, "customer_autogiro_single_amount", resetValue);
				});
			}
			else {
				console.log("_onNameIsinChange :: invalid type " + name);
			}
		}
	};

	_onExpandText = () => {
		this.setState({
			textFieldExpanded: !this.state.textFieldExpanded
		});
	};

	_onAddFund = (type) => {
		if (type === "single") {
			this.setState({
				autogiroSingleFundsActive: this.state.autogiroSingleFundsActive + 1,
				autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_single_funds,
					this.state.autogiroSingleFundsActive + 1,
					"single"
				)
			});
		}
		else if (type === "monthly") {
			this.setState({
				autogiroMonthlyFundsActive: this.state.autogiroMonthlyFundsActive + 1,
				autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_monthly_funds,
					this.state.autogiroMonthlyFundsActive + 1,
					"monthly"
				)
			});
		}
		else {
			console.log("_onAddFund :: invalid type " + type);
		}
	};

	_onRemoveFund = (type) => {

		if (type === "single") {
			let activeFundsBeforeRemove = this.state.autogiroSingleFundsActive;
			let newStateProps = {
				autogiroSingleFundsActive: activeFundsBeforeRemove - 1,
				autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_single_funds,
					activeFundsBeforeRemove - 1,
					"single"
				),
				fields: this.state.fields
			};

			/**
			 * Clear all rows above the row that we just removed
			 */
			for (let i = (activeFundsBeforeRemove - 1); i < newStateProps.fields.customer_autogiro_single_funds.length; i++) {
				newStateProps["customer_autogiro_single_fund_" + (i + 1) + "_index"] = -1;
				newStateProps.fields.customer_autogiro_single_funds[i][["customer_autogiro_single_fund_" + (i + 1) + "_name"]] = "";
				newStateProps.fields.customer_autogiro_single_funds[i][["customer_autogiro_single_fund_" + (i + 1) + "_isin"]] = "";
				newStateProps.fields.customer_autogiro_single_funds[i][["customer_autogiro_single_fund_" + (i + 1) + "_percentage"]] = "0";
			}

			this.setState(newStateProps);
		}
		else if (type === "monthly") {
			let activeFundsBeforeRemove = this.state.autogiroMonthlyFundsActive;
			let newStateProps = {
				autogiroMonthlyFundsActive: activeFundsBeforeRemove - 1,
				autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_monthly_funds,
					activeFundsBeforeRemove - 1,
					"monthly"
				),
				fields: this.state.fields
			};

			/**
			 * Clear all rows above the row that we just removed
			 */
			for (let i = (activeFundsBeforeRemove - 1); i < newStateProps.fields.customer_autogiro_monthly_funds.length; i++) {
				newStateProps["customer_autogiro_monthly_fund_" + (i + 1) + "_index"] = -1;
				newStateProps.fields.customer_autogiro_monthly_funds[i][["customer_autogiro_monthly_fund_" + (i + 1) + "_name"]] = "";
				newStateProps.fields.customer_autogiro_monthly_funds[i][["customer_autogiro_monthly_fund_" + (i + 1) + "_isin"]] = "";
				newStateProps.fields.customer_autogiro_monthly_funds[i][["customer_autogiro_monthly_fund_" + (i + 1) + "_percentage"]] = "0";
			}

			this.setState(newStateProps);
		}
		else {
			console.log("_onAddFund :: invalid type " + type);
		}

	};

	_onPercentageSingleFieldChange = (name, value) => {
		const index = name.substring(0, name.indexOf("_"));
		const fieldName = name.substring(name.indexOf("_") + 1);

		if (value < 0 || value === "") {
			value = 0;
		}
		value = parseInt(value, 10);


		if (name.indexOf("_monthly") > -1) {
			const newFunds = this.state.fields.customer_autogiro_monthly_funds;
			newFunds[index][fieldName] = value;

			this.setState({
				fields: {
					...this.state.fields,
					customer_autogiro_monthly_funds: newFunds
				},
				autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(newFunds, this.state.autogiroMonthlyFundsActive, "monthly")
			});
		}
		else if (name.indexOf("_single") > -1) {
			const newFunds = this.state.fields.customer_autogiro_single_funds;
			newFunds[index][fieldName] = value;

			this.setState({
				fields: {
					...this.state.fields,
					customer_autogiro_single_funds: newFunds
				},
				autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(newFunds, this.state.autogiroSingleFundsActive, "single")
			});
		}
		else {
			console.log("_onPercentageSingleFieldChange :: invalid type " + name);
		}
	};

	_calculateFundsPercentagesTotal(funds, fundsActive, type) {
		let percentagesSum = 0;
		for (let i = 0; i < fundsActive; i++) {
			const fundInfo = funds[i];
			percentagesSum += parseInt(fundInfo["customer_autogiro_" + type + "_fund_" + (i + 1) + "_percentage"], 10);
		}
		return percentagesSum;
	}

	_onClearingFieldChange = (name, value) => {
		// Remove all non-numbers
		value = value.replace(/[^0-9]+/g, "");

		// Limit clearing numbers to 4 numbers, we'll show a message that says to enter only first four for the
		// banks with longer numbers
		if (value.length >= 4) {
			value = value.substring(0, 4);
		}

		let valid = (this.state.fields.customer_account_bank === '-') ?
			true :
			Validator.validateClearingNumber(value, this.state.fields.customer_account_bank, this.props.availableBanks);

		CobHelpers.onViewFieldChange.call(this, name, value, valid);
	};

	_onAccountFieldChange = (name, value) => {
		// Remove dashes
		value = value.replace("-", "");
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldChange = (name, value) => {
		/**
		 * For the single deposit and monthly savings field treat zero as if the value has not been entered
		 */
		if ((name === 'customer_autogiro_single_amount' || name === 'customer_autogiro_monthly_amount') && value === "0") {
			value = "";
		}
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			},
			autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(
				this.state.fields.customer_autogiro_single_funds,
				this.state.autogiroSingleFundsActive,
				"single"
			),
			autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(
				this.state.fields.customer_autogiro_monthly_funds,
				this.state.autogiroMonthlyFundsActive,
				"monthly"
			)
		});
	};

	_onFieldBlur = (name) => {
		if (name === 'customer_account_bank_clearingno') {
			CobHelpers.onViewFieldBlur.call(this, name, null, true);
		}
		else {
			CobHelpers.onViewFieldBlur.call(this, name);
		}
	};

	_fieldValidator = (name, value) => {
		if (name === 'customer_account_bank_no') {
			return this._isValidBankAccountNo(false, value, this.state.fields.customer_autogiro_bank_clearingno);
		}

		return value.length > 0;
	};

	_onChangeAutogiroSelect = ({type, name}, option, index) => {
		name = name || option.name;
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});


		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_getProductLabel() {
		return Autogiro.productLabel;
	}
}

// PRIVATE FUNCTIONS
function _getFields() {
	let fieldsArray = [
		"customer_account_bank",
		"customer_account_bank_custom",
		"customer_account_bank_no",
		"customer_account_bank_clearingno",
		"customer_autogiro",

		"checkbox_autogiro_single",
		"customer_autogiro_single_amount",

		"checkbox_autogiro_monthly",
		"customer_autogiro_monthly_amount"
	];

	for (let i = 1; i <= 18; i++) {
		fieldsArray.push("customer_autogiro_single_fund_" + i + "_name");
		fieldsArray.push("customer_autogiro_single_fund_" + i + "_isin");
		fieldsArray.push("customer_autogiro_single_fund_" + i + "_percentage");

		fieldsArray.push("customer_autogiro_monthly_fund_" + i + "_name");
		fieldsArray.push("customer_autogiro_monthly_fund_" + i + "_isin");
		fieldsArray.push("customer_autogiro_monthly_fund_" + i + "_percentage");
	}

	return fieldsArray;
}

function _createProductClassOptions() {
	return [
		{label: "Ja", value: "yes"},
		{label: "Nej", value: "no"}
	];
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	const fundsSingle = [];
	const fundsMonthly = [];

	for (let i = 1; i <= 18; i++) {
		const fundPercentage = (i === 1) ? "100" : "0";

		fundsSingle.push({
			["customer_autogiro_single_fund_" + i + "_name"]: "",
			["customer_autogiro_single_fund_" + i + "_isin"]: "",
			["customer_autogiro_single_fund_" + i + "_percentage"]: fundPercentage
		});

		fundsMonthly.push({
			["customer_autogiro_monthly_fund_" + i + "_name"]: "",
			["customer_autogiro_monthly_fund_" + i + "_isin"]: "",
			["customer_autogiro_monthly_fund_" + i + "_percentage"]: fundPercentage
		});
	}

	let initialState = {
		textFieldExpanded: false,
		autogiroSingleFundsActive: 1,
		autogiroSingleFundsSharesTotal: 0,
		autogiroMonthlyFundsActive: 1,
		autogiroMonthlyFundsSharesTotal: 0,
		products: [],

		fields: {
			"customer_account_bank": "",
			"customer_account_bank_custom": "",
			"customer_account_bank_no": "",
			"customer_account_bank_clearingno": "",
			"customer_autogiro": {options: _createProductClassOptions()},

			"checkbox_autogiro_single": {
				checked: false
			},
			"customer_autogiro_single_amount": "",
			"customer_autogiro_single_funds": fundsSingle,

			"checkbox_autogiro_monthly": {
				checked: false
			},
			"customer_autogiro_monthly_amount": "",
			"customer_autogiro_monthly_funds": fundsMonthly
		},
		validFields: {}
	};

	for (let i = 1; i <= 18; i++) {
		initialState["customer_autogiro_single_fund_" + i + "_index:"] = -1;
		initialState["customer_autogiro_monthly_fund_" + i + "_index:"] = -1;
	}

	return initialState;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/odin/Autogiro.js